import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

import { AutocompleteResult } from '../../../models/autocomplete-result';

@Component({
  selector: 'app-multi-select-search',
  templateUrl: './multi-select-search.component.html',
  styleUrls: ['./multi-select-search.component.scss']
})
export class MultiSelectSearchComponent implements OnInit, OnChanges {
  @Input() label: string;

  @Input() resultsHeightCssName: string = 'short';

  @Input() returnOnlyValue: boolean = true

  @Input() selectionHeightCssName: string = 'medium';

  @Input() searchOptions: Array<AutocompleteResult> = [];

  @Input() selectedOptions: Array<AutocompleteResult | string> = [];

  @Output() selected: EventEmitter<Array<AutocompleteResult | string>> = new EventEmitter<Array<AutocompleteResult | string>>();

  selectedOptionsUi: Array<AutocompleteResult> = [];

  selectedResult: AutocompleteResult | null;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.selectedOptions) 
      this.setSelection();
  }

  onAdd(selectedResult: any): void {
    selectedResult.checked = true;
    this.onChange();
  }

  onChange(): void {
    this.selectedResult  = null;
    let selectedOptions: Array<AutocompleteResult> = this.searchOptions.filter((options) => options.checked);
    this.selectedOptions = selectedOptions;
    if(this.returnOnlyValue)
      this.selected.emit(selectedOptions.map((option) => option.value));
    else
      this.selected.emit(selectedOptions);    
    this.setSelection();
  }

  onRemove(selectedResult: any): void {
    selectedResult.checked = false;
    this.onChange();
  }

  setSelection() {
    this.selectedOptionsUi = [];
    let selectedOptions: Array<any> = this.selectedOptions;
    for(let option of selectedOptions) {
      if(option.hasOwnProperty('label')){
        this.selectedOptionsUi.push(option);
      }else{
        let result: AutocompleteResult | undefined = this.searchOptions.find(searchOption => searchOption.value == option);
        if(result){
          this.selectedOptionsUi.push(result);
        }
      }
    }
  }

  toggleResult(selectedResult: any): void { 
    selectedResult.checked = !selectedResult.checked;  
    this.onChange();
  }
}
